import { typographyTokens, typeScale } from '@/theme/tokens';

export const chartAxisLabelFontSize = `${String(typeScale.sm)}px`;
export const chartAxisLabelFontSizePx = typeScale.sm;
export const chartAxisLabelFontWeight = typographyTokens.body.fontWeight;
export const chartAxisLabelOpacity = 0.82;
export const chartAxisLineOpacity = 0.72;
export const chartGridLineOpacity = 0.58;
export const chartLegendFontSizePx = typeScale.sm;
export const chartLegendLineHeight = 1.35;
